import { Dispatch, SetStateAction, createContext, useContext } from 'react';

type StepperState = {
  activeStep: number;
  setActiveStep: Dispatch<SetStateAction<number>>;
  totalSteps: number;
  onComplete: () => Promise<void>;
  stepLabel: string;
};

export const StepperContext = createContext<StepperState>({
  activeStep: 0,
  setActiveStep: () => {},
  totalSteps: 0,
  onComplete: async () => {},
  stepLabel: 'unknown',
});

export const useStepperContext = () => {
  const context = useContext(StepperContext);
  if (!context) {
    throw new Error(
      'useStepperContext must be used within a StepperContextProvider',
    );
  }
  return context;
};
